<template>
  <b-card no-body>
    <b-card-header class="d-flex align-items-center justify-content-between">
      <b-card-title>AI Logs</b-card-title>
      <b-card-sub-title
        style="margin-top: 4px"
        class="font-small-3"
      >
        Son 10 Kayıt
      </b-card-sub-title>
    </b-card-header>
    <b-table
      striped
      responsive
      :items="dataList"
      :fields="fields"
    >
      <template #cell(assistant)="data">
        <b-link :to="'/ai-logs/view/' + data.item.id">
          <div class="font-small-3 text-body">
            {{ data.item.assistant }}
          </div>
          <div class="font-small-2 text-info">
            {{ data.item.model }}
          </div>
        </b-link>
      </template>
      <template #cell(sites)="data">
        <div>
          <div class="text-body font-weight-bold">
            {{ data.item.sites.company }}
          </div>
          <div class="text-muted font-small-2">
            {{ data.item.sites.site_name }}
          </div>
        </div>
      </template>
      <template #cell(total_tokens)="data">
        <div>
          <b-badge
            v-if="data.item.total_tokens"
            variant="light-info"
            pill
            class="w-100"
          >
            {{ data.item.total_tokens }}
          </b-badge>
          <div v-else>
            -
          </div>
        </div>
      </template>
      <template #cell(createdAt)="data">
        <div>
          {{ moment(data.item.createdAt).format('DD.MM.YYYY HH:mm') }}
        </div>
      </template>
    </b-table>
  </b-card>
</template>
<script>
import {
  BCard, BCardHeader, BCardTitle, BTable, BCardSubTitle, BLink, BBadge,
} from 'bootstrap-vue'

export default {
  name: 'TablePublished',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BTable,
    BCardSubTitle,
    BLink,
    BBadge,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'assistant',
          label: 'Asistan',
        },
        {
          key: 'sites',
          label: 'Abone',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'total_tokens',
          label: 'Token',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'createdAt',
          label: 'Tarih',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
    }
  },
}
</script>
